import script from "./AppCopyright.vue?vue&type=script&setup=true&lang=js"
export * from "./AppCopyright.vue?vue&type=script&setup=true&lang=js"

import "./AppCopyright.vue?vue&type=style&index=0&id=4c974184&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c974184"]])

export default __exports__